<template>
    <card class="card-default">
        <card-header>Invites Overview</card-header>
        <card-body class="pt-0" v-if="loading">
            <card-spinner size="large" style="height: 240px"></card-spinner>
        </card-body>
        <card-body v-if="!loading">
            <div class="width-wrapper">
                <doughnut-chart :chart-data="chartData" :options="options" :width="210" :height="210"></doughnut-chart>
                <div class="centralize-info">
                    <div class="d-flex" v-for="(info, index) in names">
                        <div class="square" :style="{backgroundColor: bgColors[index]}"></div>
                        <div class="strong text-camelize">{{ info }}</div>
                    </div>
                </div>
            </div>
        </card-body>
    </card>
</template>

<script>
    import {DoughnutChart} from './../shared/charts';
    import {mapState} from 'vuex';

    export default {
        components: {DoughnutChart},

        props: {
            type: {default: 'public'},
        },

        data() {
            return {
                loading: true,
                small_loading: false,
                data: [],
                bgColors: ['#0374d7', '#BBDEFB', '#e6e6e6', '#C8E6C9', '#66BB6A'],
                options: {
                    responsive: false,
                    legend: {display: false},
                    cutoutPercentage: 79
                }
            };
        },

        created() {
            this.loading = true;
            this.fetchInvitesOverview().then(() => this.loading = false);
        },

        computed: {
            ...mapState(['filter']),
            names() {
                return this.data.map(d => d.name);
            },
            values() {
                return this.data.map(d => d.value);
            },
            labels() {
                return this.data.map(d => d.label);
            },
            chartData() {
                return {
                    datasets: [{
                        data: this.values,
                        backgroundColor: this.bgColors,
                        borderWidth: 0
                    }],
                    labels: this.labels
                };
            }
        },

        watch: {
            filter() {
                this.fetchInvitesOverview();
            },
        },

        methods: {
            fetchInvitesOverview() {
                const params = {
                    ...this.filter,
                    type: this.type,
                };
                return this.$http.get(this.$laroute.route('api.invites.overview'), {params})
                    .then(response => this.data = response.data);
            },
        }
    };
</script>


<style lang="sass" scoped>
    .card-body
        z-index: 1

    .width-wrapper
        padding: .5rem 2rem
        display: flex
        justify-content: center
        position: relative

    .centralize-info
        position: absolute
        top: 3rem
        font-size: .7rem
        padding-left: .2rem
        vertical-align: vertical
        z-index: -1

    .square
        height: 12px
        width: 12px
        margin-right: .2rem
        margin-bottom: 1rem
        border-radius: 2px
        z-index: -1
</style>
